import { useLocation, useNavigate } from 'react-router';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useAuth } from '../lib/AuthContext';
import { navGroups } from './navigation';

export default function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { hasRole } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  function go(path: string) {
    navigate(path);
    onNavigate?.();
  }

  return (
    <div>
      <Toolbar />
      {navGroups(hasRole('admin'), hasRole('admin') || hasRole('vorstand')).map((group) => (
        <List
          key={group.title}
          subheader={
            <ListSubheader component="div" disableSticky>
              {group.title}
            </ListSubheader>
          }
        >
          {group.items.map((item) => (
            <ListItemButton
              key={item.path}
              selected={location.pathname === item.path}
              onClick={() => go(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
      ))}
    </div>
  );
}
